if (!customElements.get('leo-scroller')) {
  customElements.define(
    'leo-scroller',
    class LeoScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-leo-track]');
        if (!this.track) return;
        const nav = document.querySelector(`[data-leo-nav="${this.track.id}"]`);
        this.prev = nav ? nav.querySelector('[data-leo-prev]') : this.querySelector('[data-leo-prev]');
        this.next = nav ? nav.querySelector('[data-leo-next]') : this.querySelector('[data-leo-next]');
        this.onScroll = this.onScroll.bind(this);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
        if (this.hasAttribute('data-leo-center-current')) this.centerCurrent();
        this.onScroll();
      }

      centerCurrent() {
        const current = this.track.querySelector('[aria-current="page"]');
        if (!current) return;
        const item = current.closest('li') || current;
        const left = item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2;
        this.track.scrollLeft = Math.max(0, left);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step() {
        if (this.dataset.leoStep === 'page') return this.track.clientWidth * 0.7;
        const slide = this.track.firstElementChild;
        if (!slide) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / (slide.getBoundingClientRect().width + gap)));
        return (slide.getBoundingClientRect().width + gap) * perView;
      }

      go(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: this.step() * direction, behavior: reduce ? 'auto' : 'smooth' });
      }

      onScroll() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= max;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        this.classList.toggle('is-overflowing', max > 0);
        this.classList.toggle('is-at-start', atStart);
        this.classList.toggle('is-at-end', atEnd);
      }
    }
  );
}